export default "__VITE_ASSET__CwhgM_z4__"